import React, { useEffect, useState } from 'react';
import arrow_enter from '../../../images/quiz/Arrow.png'
import Button from '../Button';

import './EnterButton.css';

const EnterButton = (props) => {
    let cl = props.className ? props.className : ""
    cl += "enter-button"
    return <Button {...props} pill className={cl} > 
        <div className="enter" >
            <img src={arrow_enter} />
        </div>
    </Button>};

export default EnterButton;